// create a hook that will determine if the prescription is upsell, initial or refill and add it to visit metadata
/// use orders, pathname, and prescriptions(if needed)

import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useGetOrdersQuery } from "src/api/services/ordersApi";
import { OrderTypeEnum } from "src/api/types";
import { Paths } from "src/constants/paths";

export function useDeterminePrescriptionType(product_id: number) {
  const { data: orders = [] } = useGetOrdersQuery({ product_id });
  const { pathname } = useLocation();
  const isUpsell = useMemo(() => pathname.includes(Paths.ADD_ONS), [pathname]);

  if (orders == null || orders.length === 0) {
    return isUpsell ? OrderTypeEnum.Upsell : OrderTypeEnum.Initial;
  }

  return OrderTypeEnum.Refill;
}
